import React, { CSSProperties } from 'react'

import { IconButton } from './IconButton'
import { PointCardIcon } from '../atoms/icons/PointCardIcon'

function Label() {
  const style: CSSProperties = {
    fontSize: '12px',
    fontWeight: 'bold',
    textAlign: 'center',
  }
  return (
    <>
      <div style={style}>カード情報</div>
    </>
  )
}

export function PointCardButton() {
  return <IconButton icon={PointCardIcon} label={Label} />
}
